import { render, staticRenderFns } from "./SliceProfileList.vue?vue&type=template&id=6c161b88&"
import script from "./SliceProfileList.vue?vue&type=script&lang=js&"
export * from "./SliceProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports